import { PERCENT_DECIMALS, PLP_DECIMALS } from "pages/Event/hooks/constants";
import { BigNumber, BigNumberish } from "@ethersproject/bignumber";
import React from "react";
import { formatUnits } from "@ethersproject/units";

export const useProgress = (min: BigNumberish, max: BigNumberish, current: BigNumberish) => {
  const _min = BigNumber.from(min);
  const _max = BigNumber.from(max);
  const _current = BigNumber.from(current);

  const currentLimited = React.useMemo(() => {
    if (_current.gt(_max)) {
      return _max;
    }
    if (_current.lt(_min)) {
      return _min;
    }
    return _current;
  }, [_current, _min, _max]);

  const progress = React.useMemo(() => {
    const divisor = BigNumber.from(10).pow(PERCENT_DECIMALS);

    return parseFloat(formatUnits(currentLimited.sub(_min).mul(divisor).div(_max.sub(_min)), PLP_DECIMALS));
  }, [currentLimited, _min, _max]);

  return {
    progress,
    currentLimited,
  };
};
